import React, { useState } from "react";
import { Form, Button, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import { useLogin } from "../../../hooks/useLogin"; // Import the useLogin hook

const VerificationForm = () => {
  const [code, setCode] = useState("");
  const [alert, setAlert] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;
  const { verifyCode, isLoading } = useLogin();

  const handleVerify = async (e) => {
    e.preventDefault();

    // Ensure email and code are strings and not blank
    const emailStr = String(email || "").trim();
    const codeStr = String(code || "").trim();

    if (!emailStr || !codeStr) {
      setAlert({
        variant: "danger",
        message: "Email and verification code must not be blank.",
      });
      return;
    }

    const response = await verifyCode(emailStr, codeStr);

    if (response === "success") {
      setAlert({
        variant: "success",
        message: "Verification successful! Redirecting to login...",
      });

      setTimeout(() => {
        navigate("/");
      }, 2000);
    } else {
      setAlert({
        variant: "danger",
        message: response || "Invalid code. Please try again.",
      });
    }
  };

  return (
    <>
      {alert && (
        <Alert
          variant={alert.variant}
          onClose={() => setAlert(null)}
          dismissible
        >
          {alert.message}
        </Alert>
      )}
      <h2 className="form-header">Verify Your Email</h2>
      <p className="form-desc">
        A verification code has been sent to your email{email}
      </p>
      <div className="col-6">
        <Form className="form-box">
          <Form.Group className="mb-3" controlId="formBasicCode">
            <Form.Label className="text-above-box">
              Enter Verification Code
            </Form.Label>
            <Form.Control
              type="text"
              placeholder=""
              onChange={(e) => setCode(e.target.value)}
            />
          </Form.Group>
          <div className="d-grid gap-2">
            <Button
              variant="btn btn-primary login-buttomn"
              type="submit"
              onClick={handleVerify}
              disabled={isLoading}
            >
              {isLoading ? "Verifying..." : "Verify"}
            </Button>
          </div>

          <h6 className="form-register-link">
            You already have an account? Please{" "}
            <Link to="/" className="link-to">
              login
            </Link>
            .
          </h6>

          <h6 className="form-register-link">
            Back to{" "}
            <Link to="/register" className="link-to">
              register
            </Link>
            .
          </h6>
        </Form>
      </div>
    </>
  );
};

export default VerificationForm;
